import React, { useEffect, useState } from "react";
import ConsultantLayout from "../commonlayouts/consultantlayout.js";
import CandidateLayout from "../commonlayouts/candidatelayout.js";
import Axios from "axios";
import { GetCandidateById, GetJobRoles, GetCourseInfo } from "../apiconstants/constants.js";
import { json, Link, useLocation,useNavigate } from "react-router-dom";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Modal from 'react-bootstrap/Modal';
import LoadingSpinner from "../helpers/loadingspinner.js";
import { useCountry } from "../contexts/countrycodecontext.js";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const EvaluationEachViewCandidateDetailsByCandidateGUid = () => {
    let query = useQuery();
    const jobPostID = query.get("jobpost");
    console.log(jobPostID)
    const guid = query.get("guid");
    let Guid="";
    const {selectedCountry} = useCountry();
    const userguid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const email = localStorage.getItem("email")
    const roleID = localStorage.getItem("roleID")
    
    if(roleID==3){
     Guid = employerGuid
    }
    else{
      Guid= userguid
    }
    const [candidateDetails, setCandidateDetails] = useState(null);
    const [jobRoles, setJobRoles] = useState([]);
    const [qualifications, setQualifications] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState({ title: "", url: "" });

    const fetchJobRoles = async () => {
    const getApiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
        try {
            const response = await Axios.get(getApiUrl);
            setJobRoles(response.data);
        } catch (error) {
            console.error("Error fetching job roles", error);
        }
    };

    const fetchQualifications = async () => {
        const getApiUrl = GetCourseInfo.APIURL;
        try {
            const response = await Axios.get(getApiUrl);
            setQualifications(response.data);
        } catch (error) {
            console.error("Error fetching qualifications", error);
        }
    };

    const GetCandidateDetails = async () => {
        const GetapiUrl = GetCandidateById.APIURL;
        const params = { guid: guid };

        try {
            const result = await Axios.post(GetapiUrl, params);
            setCandidateDetails(result.data);
        } catch (error) {
            console.error("Error fetching candidate details:", error);
        }
    };

    const handleShowModal = (title, url) => {
        setModalContent({ title, url });
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    useEffect(() => {
        fetchJobRoles();
        fetchQualifications();
        GetCandidateDetails();
    }, [selectedCountry]);
    // const getExperienceText = (experience) => {
    //     if (!experience) return '';
    //     const lowerCaseExperience = experience.toLowerCase();
    //     return lowerCaseExperience.includes('years') ? experience : `${experience} years`;
    //   };
    const getExperienceText = (experience) => {
        if (!experience) return '';
        return experience?.toLowerCase().includes('years') ? experience : `${experience} years`;
      };
      
    const getJobRoleName = (id) => {
        const jobRole = jobRoles.find(role => role.jobRoleId == id);
        return jobRole ? jobRole.jobRole : "";
    };

    const getQualificationName = (id) => {
        const qualification = qualifications.find(q => q.qualificationID == id);
        return qualification ? qualification.courseName : "";
    };

  const renderAttachment = (url, file, html) => {
  if (html) {
    return (
      <div
        style={{ maxHeight: "500px", overflowY: "auto" }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }
 
  const name =
    (file && file.name?.toLowerCase()) ||
    (url && url.split("/").pop()?.toLowerCase()) ||
    "";
 
  if (!url) {
    return <div>File not found.</div>;
  }
 
  if (name.endsWith(".pdf")) {
    return (
      <iframe
        src={url}
        style={{ width: "100%", height: "500px", border: "none" }}
        title="PDF Preview"
      />
    );
  }
 
  // ✅ Image
 if (name.match(/\.(jpg|jpeg|png)$/)) {
    return (
      <div style={{ textAlign: "center" }}>
        <img
          src={url}
          alt="Image Preview"
          style={{
            maxWidth: "100%",
            maxHeight: "500px",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          }}
        />
        <div style={{ marginTop: "10px" }}>
          <a
            href={url}
            download={name.replace(/^[0-9a-fA-F-]+_/, "")} // clean name
            target="_blank"
            rel="noreferrer"
            style={{
              textDecoration: "none",
              color: "#007bff",
              fontWeight: "500",
            }}
          >
            ⬇️ Download Image
          </a>
        </div>
      </div>
    );
  }
 
  // ✅ HTML
  if (name.endsWith(".html") || name.endsWith(".htm")) {
    return (
      <iframe
        src={url}
        title="HTML Preview"
        style={{ width: "100%", height: "500px", border: "none" }}
      />
    );
  }
 
  // ✅ DOCX
  if (name.endsWith(".docx")) {
    if (url?.startsWith("https")) {
      return (
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`}
          title="DOCX Preview"
          style={{ width: "100%", height: "500px", border: "none" }}
        />
      );
    } else {
      return (
        <div>
          <p>
            DOCX preview not supported for local files.{" "}
            <a href={url} target="_blank" rel="noreferrer">
              Download
            </a>
          </p>
        </div>
      );
    }
  }
 
  return (
    <div>
      <p>
        Preview not supported for this file type.{" "}
        <a href={url} target="_blank" rel="noreferrer">
          Download
        </a>
      </p>
    </div>
  );
};
 
const safeValue = (value) => 
  (value === null || value === undefined || value === "null" || value === "undefined") 
    ? "" 
    : value;

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    };
const handleDownload = (url) => {
  const fileExtension = url.split('.').pop().toLowerCase();

  const link = document.createElement("a");
  link.href = url;

   if (["pdf", "html", "htm"].includes(fileExtension)) {
    // open in a new tab instead of downloading
    link.target = "_blank";
  } else {
    // force download for other file types
    link.setAttribute("download", "");
  }

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


    return (
        <ConsultantLayout>
            {candidateDetails ? (
                <div className="container-fluid">
                       <div className='mb-3 mt-3' style={{ display: 'flex', alignItems: 'center' }}>
                                          <Link to={`/Employer/ViewEvaluationResults?jobPost=${jobPostID}`}>
                                              <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16 }} aria-hidden="true"></i>
                                          </Link>
                                          <h2 className="" style={{ color: "#00a7ac", marginLeft: '10px', marginBottom: '0', marginTop: '0' }}>Candidate Details</h2>
                                      </div>
                    <hr />
                    <div className="card shadow-lg mt-5 p-5" style={{ border: "none" }}>
                        <div className="row mt-2">
                            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-fullName">Full Name</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-user icons"></i> {candidateDetails.fullName}</p>
                                </OverlayTrigger>
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-email">Email</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-envelope icons"></i> {candidateDetails.email}</p>
                                </OverlayTrigger>
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-mobileNumber">Mobile Number</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-phone icons"></i> {candidateDetails.mobileNumber}</p>
                                </OverlayTrigger>
                                                                    
                               {candidateDetails.gender !=null &&   candidateDetails.gender !== "null" && 
                               (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-gender">Gender</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-venus-mars icons"></i> {candidateDetails.gender}</p>
                                </OverlayTrigger>)}

                              {candidateDetails.address !=null &&   candidateDetails.address  !== "null" &&
                              ( <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-address">Address</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-map-marker icons"></i> {candidateDetails.address}</p>
                                </OverlayTrigger>)}
                                {candidateDetails.dob  != null &&   candidateDetails.dob  !== "null" &&
                                (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-dob">Date of Birth</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-birthday-cake icons"></i> {candidateDetails.dob}</p>
                                </OverlayTrigger>)}
                                {candidateDetails.maritalStatus != null &&   candidateDetails.maritalStatus !== "null" &&  
                                (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-maritalStatus">Marital Status</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-heart icons"></i> {capitalizeFirstLetter(candidateDetails.maritalStatus)}</p>
                                </OverlayTrigger>)}
                                   {candidateDetails.experience !=null &&   candidateDetails.experience !== "null" && 
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-experience">Experience</Tooltip>}>
        <p className="text-para"><i className="fa fa-briefcase icons"></i> {getExperienceText(candidateDetails.experience)}</p>
      </OverlayTrigger> }

                                {candidateDetails.technicalSkill != null &&   candidateDetails.technicalSkill !== "null" &&  
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-technicalSkill">Technical Skill</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-cogs icons"></i> {candidateDetails.technicalSkill}</p>
                                </OverlayTrigger>}
                                  {candidateDetails.highestEducation !=null &&   candidateDetails.highestEducation !== "null" && 
                               (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-gender">Highest Education</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-graduation-cap icons"></i> {candidateDetails.highestEducation}</p>
                                </OverlayTrigger>)}
                                {selectedCountry == 2 &&
  candidateDetails.workAuthorizationandValidity !== null &&
  candidateDetails.workAuthorizationandValidity !== "null" && (
    <OverlayTrigger
      placement="bottom"
      overlay={
        <Tooltip id="tooltip-technicalSkill">
          Work Authorization and Validity
        </Tooltip>
      }
    >
      <p className="text-para">
        <i className="fa fa-cogs icons"></i> {candidateDetails.workAuthorizationandValidity}
      </p>
    </OverlayTrigger>
)}

  {candidateDetails.candidateType  !== null && candidateDetails.candidateType !== "null"  && (      
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">Candidate Type</Tooltip>}>
                                    <p className="text-para"><i className="fas fa-hourglass-half icons"></i> {safeValue(candidateDetails.candidateType)}</p>
                                </OverlayTrigger>)}

                                {candidateDetails.employerName !== null && candidateDetails.employerName!== "null" && 
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-technicalSkill">Employer Name</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-cogs icons"></i> {candidateDetails.employerName}</p>
                                </OverlayTrigger>}
                                
                                {candidateDetails.ssn !== null && candidateDetails.ssn !== "null" && 
                                (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">SSN</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-building icons"></i> {candidateDetails.ssn}</p>
                                </OverlayTrigger>)}
                                {candidateDetails.passportNo !== null && candidateDetails.passportNo !== "null" && 
                                (<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">Passport Number</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-id-card icons"></i> {candidateDetails.passportNo}</p>
                                </OverlayTrigger>)}
   

                 </div>
                            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                      
                                {candidateDetails.createdBy  !== null && candidateDetails.createdBy !== "null"  && (      
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-workMode">CreatedBy</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-user icons"></i> {candidateDetails.createdBy}</p>
                                </OverlayTrigger>)}
                      
  {candidateDetails.priority !== null && candidateDetails.priority !== "null" && (
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip id="tooltip-workMode">Priority</Tooltip>}
  >
    <p className="text-para">
      <i className="fa fa-building icons"></i>    {candidateDetails.priority }
    </p>
  </OverlayTrigger>
)}

{candidateDetails.profileSummery !== null && candidateDetails.profileSummery !== "null" && ( 
<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-profileSummery">Profile Summary</Tooltip>}>
    <p className="text-para"><i className="fa fa-info-circle icons"></i> {candidateDetails.profileSummery}</p>
</OverlayTrigger>)}
{(candidateDetails.jobRole !== null && candidateDetails.jobRole !== 0 && candidateDetails.jobRole !== "null" ) && (
    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-jobRole">Job Role</Tooltip>}>
        <p className="text-para"><i className="fa fa-briefcase icons"></i> {getJobRoleName(candidateDetails.jobRole)}</p>
    </OverlayTrigger>
)}

{(candidateDetails.qualificationID !== null && candidateDetails.qualificationID !== 0 && candidateDetails.qualificationID !== "null") && (
    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-qualification">Qualification</Tooltip>}>
        <p className="text-para"><i className="fa fa-graduation-cap icons"></i> {getQualificationName(candidateDetails.qualificationID)}</p>
    </OverlayTrigger>
)}

{candidateDetails.linkedInUrl !== null && candidateDetails.linkedInUrl !== "null" && (
    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-qualification">LinkedIn Url</Tooltip>}>
        <a 
            href={candidateDetails.linkedInUrl?.startsWith('http') ? candidateDetails.linkedInUrl : `https://${candidateDetails.linkedInUrl}`} 
            target="_blank" 
            rel="noopener noreferrer"
        >
            <p className="text-para">
                <i className="fa fa-graduation-cap icons mr-1"></i>
                {candidateDetails.linkedInUrl}
            </p>
        </a>
    </OverlayTrigger>
)}


                                {(candidateDetails.resume || candidateDetails.visaCopy || candidateDetails.drivingLicence) && (
  <h2 className="" style={{ color: "#00a7ac", marginLeft: '10px', marginBottom: '2', marginTop: '0' }}>
    Attachments
  </h2>
)}


{candidateDetails.resume!==null  && candidateDetails.resume  !== "null"&& (
  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-resume">Resume</Tooltip>}>
    <p className="text-para">
      <a 
        href="#" 
        style={{ fontSize: 18 }} 
        onClick={() => handleShowModal('Resume', candidateDetails.fileUrl)}
      >
        <i className="fa fa-file-alt icons"></i> View Resume
      </a>
      &nbsp;|&nbsp;
    <a
  href="#"
  style={{ fontSize: 18 }}
  onClick={(e) => {
    e.preventDefault();
    handleDownload(candidateDetails.fileUrl);
  }}
>
  <i className="fa fa-download icons"></i> Download Resume
</a>

    </p>
  </OverlayTrigger>
)}
                        <Modal show={showModal} onHide={handleCloseModal} size="lg">
                                    <Modal.Header closeButton>
                                        <Modal.Title>{modalContent.title}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {renderAttachment(modalContent.url)}
                                    </Modal.Body>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <center><LoadingSpinner /></center>
            )}
            
        </ConsultantLayout>
    );
};

export default EvaluationEachViewCandidateDetailsByCandidateGUid;





